import styled from "styled-components";
import { width } from "styled-system";
import { cover, rgba } from "polished";

import ButtonStyles from "src/utils/buttonStyles";

export const Wrapper = styled.button`
  position: relative;
  display: inline-block;
  ${width};
  margin: 0;
  padding: ${(44 - 16) / 2 / 16}em 1.75em;
  border: 0;
  border-radius: 0;
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  vertical-align: top;
  ${ButtonStyles};
  cursor: pointer;
  overflow: hidden;
  appearance: none;
  user-select: none;
  transition: color 350ms ease-out, background-color 350ms ease-out;

  &:focus {
    outline: none;
    &::after {
      opacity: 1;
    }
  }

  &:active {
    &::after {
      opacity: 1;
    }
  }

  &::after {
    content: "";
    ${cover()};
    background-color: ${props => rgba(props.theme.colors.bg.reverse, 0.1)};
    opacity: 0;
    pointer-events: none;
    transition: opacity 125ms ease-out;
  }
`;
